import { UnifiedAlarm } from '@hakimo-ui/hakimo/types';
import { FramePlayer } from '@hakimo-ui/hakimo/ui-elements';
import { useState } from 'react';
import { HOVER_MARGIN_TOP, TIMELINE_HEIGHT } from '../constants';
import { formatTime, getHoverTranslate } from './utils';

interface Props {
  position: number;
  timelineRef: React.RefObject<HTMLDivElement>;
  alarm: UnifiedAlarm;
  timezone: string;
}

export function PreviewTooltip({
  position,
  timelineRef,
  alarm,
  timezone,
}: Props) {
  // Use the alarmStartTime as the preview label. You could also compute a more refined
  // time (for example, using the timeline hover position) if needed.
  const previewTime = formatTime(new Date(alarm.alarmStartTime), timezone);
  const translateX = getHoverTranslate(position, timelineRef);
  const [currentFrameIndex, setCurrentFrameIndex] = useState(0);
  const onFrameChange = (idx: number) => setCurrentFrameIndex(idx);

  return (
    <div
      className="absolute z-20 w-1/2"
      style={{
        left: `${position}%`,
        bottom: `${TIMELINE_HEIGHT + HOVER_MARGIN_TOP}px`,
        transform: `translateX(-${translateX})`,
      }}
    >
      <span className="bg-ondark-bg-2 absolute left-1 top-1 rounded-md px-2 text-xs text-white">
        {previewTime}
      </span>
      {alarm.media.type === 'video' && (
        <video
          src={alarm.media?.video?.url}
          autoPlay
          muted
          playsInline
          className="border-ondark-text-1 rounded-md border"
        />
      )}
      {alarm.media.type === 'frames' && (
        <FramePlayer
          frames={alarm.media?.frames ?? []}
          currentFrameIndex={currentFrameIndex}
          timeZone={timezone}
          elaborateFrames
          onFrameChange={onFrameChange}
        />
      )}
    </div>
  );
}

export default PreviewTooltip;
